import { httpService } from './http.service'

import { STANDALONE_CONTENT_FOLDER } from '../../reports/standalone-report/constants'

/**
 * Service that handles content delivery
 */
class ContentService {
  /**
   * Get base content file url
   *
   * @param {string} contentId Content id
   * @returns
   */
  getBaseUrl (contentId) {
    return httpService.isStandalone
      ? STANDALONE_CONTENT_FOLDER
      : `${httpService.getBaseURL()}api/content/${contentId}/file`
  }

  /**
   * Get content file url
   *
   * @param {string} contentId Content id
   * @param {string} path Content filename
   * @param {object} options Download options
   * @param {string} options.downloadAs Download as filename
   */
  getUrl (contentId, path, { downloadAs } = {}) {
    let url = `${this.getBaseUrl(contentId)}/${path}`
    if (downloadAs) {
      url = `${url}?downloadAs=${encodeURIComponent(downloadAs)}`
    }
    return url
  }

  /**
   * Download content file
   *
   * @param {string} contentId Content id
   * @param {string} filename Content filename
   * @param {object} options Download options
   * @param {string} options.downloadAs Download as filename
   */
  async download (contentId, filename, { downloadAs } = {}) {
    window.open(this.getUrl(contentId, filename, { downloadAs }), '_blank`')
  }
}

export const contentService = new ContentService()
